export default __webpack_public_path__ + "static/media/feature-1.7a99c88a.svg";